import AutoScroll from 'embla-carousel-auto-scroll';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { Carousel, useCarousel } from 'src/components/carousel';
import { useColorScheme } from '@mui/material';
import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

export function Clients({ brands, sx, ...other }) {
  const { t } = useLocale();
  const carousel = useCarousel(
    {
      loop: true,
      slideSpacing: '24px',
      slidesToShow: 'auto',
    },
    [AutoScroll({ playOnInit: true, speed: 0.5 })]
  );
  const { mode } = useColorScheme();

  return (
    <Box
      component="section"
      sx={[
        {
          pt: { xs: 5, md: 4 },
          pb: { xs: 5, md: 10 },
          bgcolor: 'background.whitePaper',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Box
          sx={{
            mx: 'auto',
            maxWidth: 480,
            textAlign: 'center',
            mb: { xs: 5, md: 10 },
          }}
        >
          <Typography variant="h2" sx={{ fontSize: '2rem !important' }}>
            {t('Our_clients')}
          </Typography>

          {/* <Typography sx={{ color: 'text.secondary', mt: 3 }}>
            Curabitur a felis in nunc fringilla tristique. Fusce egestas elit eget lorem. Etiam
            vitae tortor.
          </Typography> */}
        </Box>

        <Carousel carousel={carousel}>
          {brands?.map((brand, index) => (
            <Paper
              key={index}
              variant="outlined"
              sx={{
                p: 1,
                minWidth: 168,
                borderRadius: 2,
                textAlign: 'center',
                bgcolor: 'common.white',
              }}
            >
              <Box
                component="img"
                alt={brand?.alt}
                src={brand?.image}
                sx={{ width: 200, height: 100, objectFit: 'contain', bgcolor: 'common.white' }}
              />
            </Paper>
          ))}
        </Carousel>
      </Container>
    </Box>
  );
}
